(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function initCcSplides() {
    if (typeof Splide === 'undefined') {
      setTimeout(initCcSplides, 50);
      return;
    }
    
    document.querySelectorAll('.cc__splide').forEach(function(el) {
      var blockId = el.getAttribute('data-block-id');
      var productCount = parseInt(el.getAttribute('data-product-count'), 10) || 0;
      
      var splide = new Splide(el, {
        type: 'slide',
        perPage: 2,
        perMove: 1,
        gap: '4px',
        padding: { left: '12px', right: '7px' },
        pagination: false,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
        arrows: false,
        // speed: 3000,
        drag: 'free',
        dragMinThreshold: { mouse: 0, touch: 30 },
        mediaQuery: 'min',
        breakpoints: {
          992: {
            perPage: 5,
            gap: '12px',
            fixedWidth: false,
            padding: { left: '0px', right: '0px' },
            drag: productCount > 5 ? true : false
          }
        }
      }).mount();

      var prevBtn = document.querySelector('#cc-arrows-' + blockId + ' .cc__arrow--prev');
      var nextBtn = document.querySelector('#cc-arrows-' + blockId + ' .cc__arrow--next');
      var arrowsContainer = document.querySelector('#cc-arrows-' + blockId);

      function updateArrows() {
        if (arrowsContainer) {
          var perPage = splide.options.perPage || 1;
          if (splide.length <= perPage) {
            arrowsContainer.classList.add('hide-arrows');
          } else {
            arrowsContainer.classList.remove('hide-arrows');
          }
        }

        if (prevBtn) {
          if (splide.index === 0) {
            prevBtn.classList.add('is-inactive');
          } else {
            prevBtn.classList.remove('is-inactive');
          }
        }
        if (nextBtn) {
          if (splide.index === splide.length - splide.options.perPage) {
            nextBtn.classList.add('is-inactive');
          } else {
            nextBtn.classList.remove('is-inactive');
          }
        }
      }

      splide.on('mounted move resized updated', updateArrows);
      updateArrows();


      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          splide.go('<');
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          splide.go('>');
        });
      }
    });

    // Smooth scroll for end of collection button
    document.querySelectorAll('.cc__end-btn-wrap a, a.cc__end-btn, .cc__end-overview-link').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href && href.startsWith('#')) {
          e.preventDefault();
          var target = document.querySelector(href);
          if (!target && href === '#product-grid') {
            target = document.querySelector('.section-collection') || document.querySelector('.collection-grid');
          }
          if (target) {
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            var offset = 0;
            var stickyToolbar = document.querySelector('.collection-sticky-wrapper');
            if (stickyToolbar) {
              offset += stickyToolbar.offsetHeight;
            }
            var header = document.querySelector('.main-header');
            if (header && document.body.classList.contains('scroll-up')) {
              offset += header.offsetHeight;
            }
            window.scrollTo({
              top: targetPosition - offset,
              behavior: 'smooth'
            });
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
		let footer = document.querySelector('footer');
		let footerContent = document.querySelector('.footer__content');
		if (!footer || !footerContent) return;
		function updateFooterHeight() {
			footer.style.minHeight = footerContent.offsetHeight + 'px';
		}
		updateFooterHeight();
		let resizeObserver = new ResizeObserver(() => {
			updateFooterHeight();
		});
		resizeObserver.observe(footerContent);
		let mutationObserver = new MutationObserver(() => {
			updateFooterHeight();
		});
		mutationObserver.observe(footerContent, {
			childList: true,
			subtree: true
		});

    const triggers = document.querySelectorAll('.footer-accordion-trigger');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const parent = this.closest('.footer-nav-col');
        const content = parent.querySelector('.footer-nav-content');
        const inner = content.querySelector('ul');
        const isOpen = parent.classList.contains('is-open');
        
        if (!isOpen) {
          // Close all other accordions
          document.querySelectorAll('.footer-nav-col').forEach(item => {
            if(item !== parent && item.classList.contains('is-open')) {
              item.classList.remove('is-open');
              const otherContent = item.querySelector('.footer-nav-content');
              if(otherContent) {
                otherContent.style.height = otherContent.scrollHeight + 'px';
                otherContent.offsetHeight; // force reflow
                otherContent.style.height = '0px';
              }
              const otherTrigger = item.querySelector('.footer-accordion-trigger');
              if(otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            }
          });
          
          parent.classList.add('is-open');
          if(content) {
            content.style.height = content.scrollHeight + 'px';
            const onTransitionEnd = function(event) {
              if (event.propertyName === 'height') {
                if (parent.classList.contains('is-open')) {
                  content.style.height = 'none';
                }
                content.removeEventListener('transitionend', onTransitionEnd);
              }
            };
            content.addEventListener('transitionend', onTransitionEnd);
          }
          this.setAttribute('aria-expanded', 'true');
        } else {
          parent.classList.remove('is-open');
          if(content) {
            content.style.height = content.scrollHeight + 'px';
            content.offsetHeight; // force reflow
            content.style.height = '0px';
          }
          this.setAttribute('aria-expanded', 'false');
        }
      });

      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

		// Hide footer when scrolled near the top (within 200px)
		const NEAR_TOP_THRESHOLD = 500;
		function updateFooterVisibility() {
			const scrollY = window.scrollY || window.pageYOffset;
			if (scrollY <= NEAR_TOP_THRESHOLD) {
				footerContent.classList.add('footer--near-top');
			} else {
				footerContent.classList.remove('footer--near-top');
			}
		}
		updateFooterVisibility();
		window.addEventListener('scroll', updateFooterVisibility, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    const STORAGE_PREFIX = 'newsletter-popup:';
    const DAY_IN_MS = 24 * 60 * 60 * 1000;

    const readStorage = (type, key) => {
      try {
        return window[type].getItem(STORAGE_PREFIX + key);
      } catch (error) {
        return null;
      }
    };

    const writeStorage = (type, key, value) => {
      try {
        window[type].setItem(STORAGE_PREFIX + key, value);
      } catch (error) {
        // Storage blocked (private mode, cookie settings): the popup just shows more often.
      }
    };

    class NewsletterPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.panel = this.querySelector('[data-newsletter-popup-panel]');
        this.isModal = this.dataset.modal === 'true';
        this.timers = [];
        this.controller = new AbortController();
        this.triggerController = new AbortController();
        const { signal } = this.controller;

        this.querySelector('.newsletter-popup__close').addEventListener('click', () => this.close(), { signal });
        // Escape on a modal dialog
        this.dialog.addEventListener(
          'cancel',
          (event) => {
            event.preventDefault();
            this.close();
          },
          { signal }
        );
        // Clicks on the overlay land on the full-screen dialog itself, not on the panel
        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.dialog && this.dataset.closeOnOverlayClick === 'true') this.close();
          },
          { signal }
        );
        document.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape' && !this.isModal && this.dialog.open) this.close();
          },
          { signal }
        );
        document.addEventListener(
          'newsletter:subscribed',
          () => writeStorage('localStorage', 'subscribed', '1'),
          { signal }
        );
        document.addEventListener(
          'click',
          (event) => {
            const opener = event.target.closest('a[href$="#newsletter-popup"], [data-newsletter-popup-open]');
            if (!opener) return;
            event.preventDefault();
            this.open();
          },
          { signal }
        );

        if (this.hasAttribute('data-design-mode')) {
          this.setupThemeEditor(signal);
          return;
        }

        if (window.location.hash === '#newsletter-popup') {
          this.open();
          return;
        }

        this.pageViews = Number(readStorage('sessionStorage', 'page-views') || 0) + 1;
        writeStorage('sessionStorage', 'page-views', String(this.pageViews));

        if (this.canAutoOpen()) this.setupTriggers();
      }

      disconnectedCallback() {
        this.controller.abort();
        this.triggerController.abort();
        this.timers.forEach(clearTimeout);
      }

      setupThemeEditor(signal) {
        const isThisSection = (event) => event.detail && event.detail.sectionId === this.dataset.sectionId;
        document.addEventListener('shopify:section:select', (event) => isThisSection(event) && this.open(), { signal });
        document.addEventListener('shopify:section:load', (event) => isThisSection(event) && this.open(), { signal });
        document.addEventListener('shopify:section:deselect', (event) => isThisSection(event) && this.close(), {
          signal,
        });
      }

      canAutoOpen() {
        if (this.dataset.hideAfterSignup === 'true' && readStorage('localStorage', 'subscribed')) return false;

        const isDesktop = window.matchMedia('(min-width: 992px)').matches;
        if (this.dataset.devices === 'desktop' && !isDesktop) return false;
        if (this.dataset.devices === 'mobile' && isDesktop) return false;

        if (this.pageViews < Number(this.dataset.minPageViews || 1)) return false;

        if (this.dataset.frequency === 'session' && readStorage('sessionStorage', 'shown')) return false;
        if (this.dataset.frequency === 'days' && Number(readStorage('localStorage', 'next-show') || 0) > Date.now()) {
          return false;
        }

        return true;
      }

      setupTriggers() {
        const { signal } = this.triggerController;
        const fire = () => {
          this.triggerController.abort();
          this.timers.forEach(clearTimeout);
          this.timers = [];
          this.openWhenReady();
        };

        if (this.dataset.delay !== '') {
          this.timers.push(setTimeout(fire, Number(this.dataset.delay) * 1000));
        }

        if (this.dataset.scrollDepth !== '') {
          const depth = Number(this.dataset.scrollDepth);
          const onScroll = () => {
            const scrollable = document.documentElement.scrollHeight - window.innerHeight;
            if (scrollable > 0 && (window.scrollY / scrollable) * 100 >= depth) fire();
          };
          window.addEventListener('scroll', onScroll, { passive: true, signal });
        }

        if (this.dataset.exitIntent === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          document.addEventListener(
            'mouseout',
            (event) => {
              if (!event.relatedTarget && event.clientY <= 0) fire();
            },
            { signal }
          );
        }
      }

      // Wait until drawers, menus, other dialogs and the configured elements (e.g. cookie banner) are closed.
      openWhenReady() {
        if (this.isPageBusy()) {
          this.timers.push(setTimeout(() => this.openWhenReady(), 1000));
          return;
        }

        this.open();
        this.recordShown();
      }

      isPageBusy() {
        if (/(^|\s)open-/.test(document.body.className)) return true;
        if (document.querySelector('dialog[open]')) return true;

        const selector = this.dataset.waitFor;
        if (!selector) return false;
        try {
          return Array.from(document.querySelectorAll(selector)).some(
            (element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden'
          );
        } catch (error) {
          return false;
        }
      }

      recordShown() {
        if (this.dataset.frequency === 'session') {
          writeStorage('sessionStorage', 'shown', '1');
        } else if (this.dataset.frequency === 'days') {
          const nextShow = Date.now() + Number(this.dataset.frequencyDays) * DAY_IN_MS;
          writeStorage('localStorage', 'next-show', String(nextShow));
        }
      }

      open() {
        if (this.dialog.open) return;

        if (this.isModal) {
          this.previouslyFocused = document.activeElement;
          this.dialog.showModal();
          this.panel.focus({ preventScroll: true });
        } else {
          // Setting the attribute (instead of show()) opens it without moving focus away from the page.
          this.dialog.setAttribute('open', '');
        }
      }

      close() {
        if (!this.dialog.open) return;

        this.dialog.close();
        if (this.isModal && this.previouslyFocused && this.previouslyFocused.isConnected) {
          this.previouslyFocused.focus({ preventScroll: true });
        }
      }
    }

    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const notifyPopup = document.querySelector('.notify-popup');
  if (notifyPopup) {
    const body = document.body;
    let notifyPrevFocus = null;

    function openNotifyPopup() {
      if (notifyPopup.parentElement !== body) {
        body.appendChild(notifyPopup);
      }
      void notifyPopup.offsetHeight;
      notifyPrevFocus = document.activeElement;
      notifyPopup.setAttribute('aria-hidden', 'false');
      notifyPopup.classList.add('is-open');
      body.classList.add('open-notify-popup');
      notifyPopup.focus();
    }

    function closeNotifyPopup() {
      notifyPopup.classList.remove('is-open');
      notifyPopup.setAttribute('aria-hidden', 'true');
      body.classList.remove('open-notify-popup');
      if (notifyPrevFocus && notifyPrevFocus.focus) notifyPrevFocus.focus();
    }

    window.openNotifyPopup = openNotifyPopup;
    window.closeNotifyPopup = closeNotifyPopup;

    // Close: close button inside the popup.
    const notifyCloseBtn = notifyPopup.querySelector('.notify-popup__close-btn');
    if (notifyCloseBtn) {
      notifyCloseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeNotifyPopup();
      });
    }

    // Close: backdrop click.
    document.addEventListener('click', function (e) {
      if (body.classList.contains('open-notify-popup') && e.target.closest('.overlay-box')) {
        closeNotifyPopup();
      }
    }, true);

    // Close: Escape key.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && body.classList.contains('open-notify-popup')) {
        closeNotifyPopup();
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;

  let mcDrawerTimeout = null;

  // Material Accordion Drawer
  const materialTitle = document.querySelector('.product-material-accordion__title');
  const materialDrawer = document.querySelector('.product-material-accordion__drawer');
  const materialClose = document.querySelector('.product-material-accordion__item__header__icon');

  function openMaterialDrawer() {
    if (mcDrawerTimeout) {
      clearTimeout(mcDrawerTimeout);
      mcDrawerTimeout = null;
    }
    materialDrawer?.classList.add('is-open');
    body.classList.add('open-mc-drawer');
  }

  function closeMaterialDrawer() {
    materialDrawer?.classList.remove('is-open');
    if (mcDrawerTimeout) clearTimeout(mcDrawerTimeout);
    mcDrawerTimeout = setTimeout(() => {
      const anyOpen = document.querySelector('.product-material-accordion__drawer.is-open, .product-accordion__drawer.is-open');
      if (!anyOpen) {
        body.classList.remove('open-mc-drawer');
      }
    }, 10);
  }

  materialTitle?.addEventListener('click', function (e) {
    e.preventDefault();
    openMaterialDrawer();
  });

  materialClose?.addEventListener('click', function (e) {
    e.preventDefault();
    closeMaterialDrawer();
  });

  // Standard Accordion Drawers
  const productAccordions = document.querySelectorAll('.product-accordion');
  productAccordions.forEach(function (acc) {
    const accTitle = acc.querySelector('.product-accordion__title');
    const blockId = acc.getAttribute('data-block-id');
    const accDrawer = document.getElementById('Drawer-' + blockId);
    const accClose = accDrawer ? accDrawer.querySelector('.product-accordion__item__header__icon') : null;

    function openAccDrawer() {
      if (mcDrawerTimeout) {
        clearTimeout(mcDrawerTimeout);
        mcDrawerTimeout = null;
      }
      accDrawer?.classList.add('is-open');
      body.classList.add('open-mc-drawer');
    }

    function closeAccDrawer() {
      accDrawer?.classList.remove('is-open');
      if (mcDrawerTimeout) clearTimeout(mcDrawerTimeout);
      mcDrawerTimeout = setTimeout(() => {
        const anyOpen = document.querySelector('.product-material-accordion__drawer.is-open, .product-accordion__drawer.is-open');
        if (!anyOpen) {
          body.classList.remove('open-mc-drawer');
        }
      }, 10);
    }

    accTitle?.addEventListener('click', function (e) {
      e.preventDefault();
      openAccDrawer();
    });

    accClose?.addEventListener('click', function (e) {
      e.preventDefault();
      closeAccDrawer();
    });
  });



  // Global Close (Backdrop Overlay click & Escape key)
  function closeAllDrawers() {
    materialDrawer?.classList.remove('is-open');
    document.querySelectorAll('.product-accordion__drawer').forEach(function (d) {
      d.classList.remove('is-open');
    });
    if (mcDrawerTimeout) clearTimeout(mcDrawerTimeout);
    mcDrawerTimeout = setTimeout(() => {
      body.classList.remove('open-mc-drawer');
    }, 10);
  }

  window.productDrawers = {
    closeAllDrawers: closeAllDrawers
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest('.overlay-box')) {
      closeAllDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllDrawers();
    }
  });

  const productGrid = document.querySelector('.product');
  const productInfo = productGrid ? productGrid.querySelector('.product-info') : null;
  const productImagesCol = productGrid ? productGrid.querySelector('.product-images') : null;
  function updateColumnHandoff() {
    if (!productGrid || !productInfo || !productImagesCol) return;
    if (window.innerWidth < 992) {
      productGrid.style.gridTemplateRows = '';
      return;
    }
    const mainHeader = document.querySelector('.main-header');
    const headerBottom = mainHeader ? Math.max(0, mainHeader.getBoundingClientRect().bottom) : 0;
    const overflow = Math.max(0, productInfo.offsetHeight - (window.innerHeight - headerBottom));
    productGrid.style.gridTemplateRows = Math.round(productImagesCol.offsetHeight + overflow) + 'px';
  }
  updateColumnHandoff();
  window.addEventListener('load', updateColumnHandoff);
  window.addEventListener('resize', updateColumnHandoff);
  if (window.ResizeObserver && productInfo && productImagesCol) {
    const handoffObserver = new ResizeObserver(updateColumnHandoff);
    handoffObserver.observe(productInfo);
    handoffObserver.observe(productImagesCol);
    const annBar = document.querySelector('.section-announcement-bar');
    if (annBar) handoffObserver.observe(annBar);
  }

  let splideInstance = null;
  function initProductSlider() {
    const sliderEl = document.querySelector('.product-images-slider');
    if (!sliderEl) return;

    if (typeof Splide === 'undefined') {
      setTimeout(initProductSlider, 50);
      return;
    }

    function handleSlider() {
      if (window.innerWidth <= 991) {
        if (!splideInstance) {
          splideInstance = new Splide(sliderEl, {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: false,
            arrows: false,
            speed: 1000,
            easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          });

          const bar = sliderEl.querySelector('.product-images__progress-bar');
          if (bar) {
            const updateProgress = function () {
              const totalSlides = splideInstance.length;
              if (totalSlides > 0) {
                const rate = Math.min((splideInstance.index + 1) / totalSlides, 1);
                bar.style.width = (100 * rate) + '%';
              }
            };
            splideInstance.on('mounted move active', updateProgress);
          }

          splideInstance.mount();
        }
      } else {
        if (splideInstance) {
          splideInstance.destroy(true);
          splideInstance = null;
        }
      }
    }

    handleSlider();
    window.addEventListener('resize', handleSlider);
  }
  initProductSlider();

  // Custom hover thumbnails, zoom cursor and vertical zoom modal functionality
  // 1. Custom cursor movement and display
  const imagesArea = document.querySelector('.product-images-slider');
  const customCursor = document.querySelector('.product-images__custom-cursor');
  const zoomInIcon = customCursor?.querySelector('.zoom-in-icon');
  const zoomOutIcon = customCursor?.querySelector('.zoom-out-icon');

  if (imagesArea && customCursor) {
    // Follow mouse
    document.addEventListener('mousemove', function (e) {
      if (window.innerWidth >= 992) {
        customCursor.style.left = e.clientX + 'px';
        customCursor.style.top = e.clientY + 'px';
      }
    });

    imagesArea.addEventListener('mouseenter', function () {
      if (window.innerWidth >= 992) {
        customCursor.style.display = 'inline-flex';
      }
    });

    imagesArea.addEventListener('mouseleave', function () {
      customCursor.style.display = 'none';
    });

    // Hide custom cursor when hovering thumbnails or other buttons inside images area
    const noCursorElements = imagesArea.querySelectorAll('.product-images__thumbnails, .product-get-the-look-sticky-container');
    noCursorElements.forEach(el => {
      el.addEventListener('mouseenter', () => {
        customCursor.style.display = 'none';
      });
      el.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 992) {
          customCursor.style.display = 'inline-flex';
        }
      });
    });
  }

  // 2. Set index on main images
  const mainImages = document.querySelectorAll('.product-images-slider .product-image');
  mainImages.forEach((img, idx) => {
    img.setAttribute('data-image-index', idx);
  });

  let isMainScrolling = false;
  let mainScrollTimeout = null;

  // 3. Click thumbnail to scroll to main image
  const mainThumbnails = document.querySelectorAll('.product-images__thumbnail');
  mainThumbnails.forEach(thumb => {
    thumb.addEventListener('click', function (e) {
      e.stopPropagation();
      const idx = this.getAttribute('data-index');
      
      // Update active thumbnail immediately
      mainThumbnails.forEach(t => {
        if (t.getAttribute('data-index') === idx) {
          t.classList.add('is-active');
        } else {
          t.classList.remove('is-active');
        }
      });

      isMainScrolling = true;
      clearTimeout(mainScrollTimeout);
      mainScrollTimeout = setTimeout(() => {
        isMainScrolling = false;
      }, 800); // match smooth scroll duration

      const targetImg = document.querySelector(`.product-images-slider .product-image[data-image-index="${idx}"]`);
      if (targetImg) {
        const imgEl = targetImg.querySelector('img') || targetImg;
        // The announcement bar and header stay stuck to the top of desktop PDPs,
        // so land the image directly below them instead of underneath them.
        let headerOffset = 0;
        const mainHeader = document.querySelector('.main-header');
        if (window.innerWidth >= 992 && mainHeader) {
          headerOffset = Math.max(0, mainHeader.getBoundingClientRect().bottom);
        }

        // Add 2px margin buffer to prevent subpixel leaking of previous slide
        const elementPosition = imgEl.getBoundingClientRect().top + window.scrollY - headerOffset + 2;

        window.scrollTo({
          top: Math.max(0, elementPosition),
          behavior: 'smooth'
        });
      }
    });
  });

  // 4. Main scroll observer to highlight active thumbnail
  if (mainThumbnails.length > 0 && window.innerWidth >= 992) {
    const observerOptions = {
      root: null,
      rootMargin: '-40% 0px -40% 0px', // slightly wider viewport range
      threshold: 0
    };
    const mainObserver = new IntersectionObserver((entries) => {
      if (isMainScrolling) return;
      if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 50) {
        return;
      }
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const idx = entry.target.getAttribute('data-image-index');
          mainThumbnails.forEach(t => {
            if (t.getAttribute('data-index') === idx) {
              t.classList.add('is-active');
            } else {
              t.classList.remove('is-active');
            }
          });
        }
      });
    }, observerOptions);

    mainImages.forEach(img => mainObserver.observe(img));

    // Force last thumbnail active when scrolled to the very bottom
    window.addEventListener('scroll', function() {
      if (isMainScrolling) return;
      if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 50) {
        mainThumbnails.forEach(t => {
          if (t.getAttribute('data-index') === String(mainThumbnails.length - 1)) {
            t.classList.add('is-active');
          } else {
            t.classList.remove('is-active');
          }
        });
      }
    });
  }

  // 5. Zoom Modal Logic
  const zoomModal = document.querySelector('.zoom-modal');
  const closeModalBtn = zoomModal?.querySelector('.zoom-modal__close-btn');
  const zoomModalImages = zoomModal?.querySelectorAll('.zoom-modal__image-wrapper');
  const modalThumbnails = zoomModal?.querySelectorAll('.zoom-modal__thumbnail');

  let isModalScrolling = false;
  let modalScrollTimeout = null;

  function openZoomModal(startIndex) {
    if (!zoomModal) return;
    zoomModal.classList.add('is-active');
    document.body.classList.add('zoom-modal-open');

    // Make the corresponding modal thumbnail active immediately
    modalThumbnails?.forEach(t => {
      if (t.getAttribute('data-index') === String(startIndex)) {
        t.classList.add('is-active');
      } else {
        t.classList.remove('is-active');
      }
    });

    isModalScrolling = true;
    clearTimeout(modalScrollTimeout);
    modalScrollTimeout = setTimeout(() => {
      isModalScrolling = false;
    }, 800);

    // Scroll to the clicked image in modal
    setTimeout(() => {
      const targetWrapper = zoomModal.querySelector(`.zoom-modal__image-wrapper[data-index="${startIndex}"]`);
      if (targetWrapper) {
        targetWrapper.scrollIntoView({ block: 'center' });
      }
    }, 50);
  }

  function closeZoomModal() {
    if (!zoomModal) return;
    zoomModal.classList.remove('is-active');
    document.body.classList.remove('zoom-modal-open');
    // Reset all zoom states
    zoomModalImages?.forEach(wrap => {
      wrap.classList.remove('is-zoomed');
      const img = wrap.querySelector('.zoom-modal__image');
      if (img) {
        img.style.transformOrigin = 'center center';
        img.style.transform = '';
        img.style.transition = '';
      }
      if (window.innerWidth < 992) {
        if (typeof wrap.resetMobileZoom === 'function') {
          wrap.resetMobileZoom(false); // Reset without animation
        }
      }
    });
    if (zoomInIcon && zoomOutIcon) {
      zoomInIcon.classList.remove('d-none');
      zoomOutIcon.classList.add('d-none');
    }
  }

  // Trigger from desktop main page images click
  mainImages.forEach(img => {
    img.addEventListener('click', function () {
      const idx = this.getAttribute('data-image-index');
      openZoomModal(idx);
    });
  });

  // Trigger from mobile slide click
  const splideSlides = document.querySelectorAll('.product-images-slider .splide__slide');
  splideSlides.forEach((slide, idx) => {
    slide.addEventListener('click', function (e) {
      // Avoid triggering when get-the-look button or details are active and clicked
      if (e.target.closest('.product-get-the-look-sticky-container')) return;
      openZoomModal(idx);
    });
  });

  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', closeZoomModal);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeZoomModal();
  });

  // Custom smooth scroll animation for custom scroll durations (3000ms)
  function smoothScrollTo(container, targetY, duration) {
    const startY = container.scrollTop;
    const difference = targetY - startY;
    const startTime = performance.now();

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Quartic ease out approximation of custom cubic-bezier
      const ease = 1 - Math.pow(1 - progress, 4);

      container.scrollTop = startY + difference * ease;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function getElementOffsetTop(element, container) {
    let offsetTop = 0;
    while (element && element !== container) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }

  // 6. Modal Thumbnail click
  modalThumbnails?.forEach(thumb => {
    thumb.addEventListener('click', function (e) {
      e.stopPropagation();
      const idx = this.getAttribute('data-index');
      
      // Update active thumbnail immediately
      modalThumbnails.forEach(t => {
        if (t.getAttribute('data-index') === idx) {
          t.classList.add('is-active');
        } else {
          t.classList.remove('is-active');
        }
      });

      // Reset zoom on other images FIRST before calculating scroll heights/offsets
      zoomModalImages?.forEach(wrap => {
        const wrapIdx = wrap.getAttribute('data-index');
        if (wrapIdx !== idx) {
          if (window.innerWidth >= 992) {
            wrap.classList.remove('is-zoomed');
            const img = wrap.querySelector('.zoom-modal__image');
            if (img) {
              img.style.transformOrigin = 'center center';
              img.style.transform = '';
              img.style.transition = '';
            }
          } else {
            if (typeof wrap.resetMobileZoom === 'function') {
              wrap.resetMobileZoom(false);
            }
          }
        }
      });

      isModalScrolling = true;
      clearTimeout(modalScrollTimeout);
      modalScrollTimeout = setTimeout(() => {
        isModalScrolling = false;
      }, 3000); // match 3000ms duration

      const targetImg = zoomModal.querySelector(`.zoom-modal__image-wrapper[data-index="${idx}"]`);
      if (targetImg) {
        const targetOffset = getElementOffsetTop(targetImg, zoomModal);
        const targetY = targetOffset - (zoomModal.clientHeight - targetImg.offsetHeight) / 2;
        const maxScroll = zoomModal.scrollHeight - zoomModal.clientHeight;
        const boundedY = Math.max(0, Math.min(maxScroll, targetY));

        smoothScrollTo(zoomModal, boundedY, 3000);
      }
    });
  });

  function updateActiveModalThumbnailOnScroll() {
    if (isModalScrolling || !zoomModal || !modalThumbnails || modalThumbnails.length === 0) return;

    // Force last thumbnail active when zoomed modal is scrolled to the very bottom
    if ((zoomModal.clientHeight + zoomModal.scrollTop) >= zoomModal.scrollHeight - 50) {
      const lastIdx = String(modalThumbnails.length - 1);
      modalThumbnails.forEach(t => {
        if (t.getAttribute('data-index') === lastIdx) {
          t.classList.add('is-active');
        } else {
          t.classList.remove('is-active');
        }
      });
      // Reset zoom on all except the last one
      zoomModalImages?.forEach(wrap => {
        const idx = wrap.getAttribute('data-index');
        if (idx !== lastIdx) {
          if (window.innerWidth >= 992) {
            wrap.classList.remove('is-zoomed');
            const img = wrap.querySelector('.zoom-modal__image');
            if (img) {
              img.style.transformOrigin = 'center center';
              img.style.transform = '';
              img.style.transition = '';
            }
          } else {
            if (typeof wrap.resetMobileZoom === 'function') {
              wrap.resetMobileZoom(false);
            }
          }
        }
      });
      return;
    }

    const modalCenter = zoomModal.getBoundingClientRect().top + (zoomModal.clientHeight / 2);
    let closestIndex = 0;
    let closestDistance = Infinity;

    zoomModalImages?.forEach(wrap => {
      const idx = parseInt(wrap.getAttribute('data-index'), 10);
      const rect = wrap.getBoundingClientRect();
      const wrapCenter = rect.top + (rect.height / 2);

      const distance = Math.abs(modalCenter - wrapCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = idx;
      }
    });

    modalThumbnails.forEach(t => {
      if (parseInt(t.getAttribute('data-index'), 10) === closestIndex) {
        t.classList.add('is-active');
      } else {
        t.classList.remove('is-active');
      }
    });

    // Reset zoom on all except the closest active one
    zoomModalImages?.forEach(wrap => {
      const idx = parseInt(wrap.getAttribute('data-index'), 10);
      if (idx !== closestIndex) {
        if (window.innerWidth >= 992) {
          wrap.classList.remove('is-zoomed');
          const img = wrap.querySelector('.zoom-modal__image');
          if (img) {
            img.style.transformOrigin = 'center center';
            img.style.transform = '';
            img.style.transition = '';
          }
        } else {
          if (typeof wrap.resetMobileZoom === 'function') {
            wrap.resetMobileZoom(false);
          }
        }
      }
    });
  }

  // 7. Modal scroll event listener to highlight active modal thumbnail
  if (zoomModal && modalThumbnails && modalThumbnails.length > 0) {
    zoomModal.addEventListener('scroll', updateActiveModalThumbnailOnScroll);
  }

  // Mobile Touch Zoom / Pan Gestures
  zoomModalImages?.forEach(wrapper => {
    const img = wrapper.querySelector('.zoom-modal__image');
    if (!img) return;

    let scale = 1;
    let translateX = 0;
    let translateY = 0;

    let startX = 0;
    let startY = 0;
    let startTx = 0;
    let startTy = 0;

    let touchStartDist = 0;
    let touchStartScale = 1;
    let touchStartMidpoint = { x: 0, y: 0 };

    let lastTapTime = 0;

    function applyTransform(animate = false) {
      if (animate) {
        img.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      } else {
        img.style.transition = 'none';
      }
      img.style.transform = `translate3d(${translateX}px, ${translateY}px, 0) scale(${scale})`;
    }

    function resetZoomState(animate = true) {
      scale = 1;
      translateX = 0;
      translateY = 0;
      applyTransform(animate);
    }

    wrapper.resetMobileZoom = resetZoomState;

    wrapper.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 992) return;

      if (e.touches.length === 1) {
        const now = Date.now();
        if (now - lastTapTime < 300) {
          if (scale > 1) {
            resetZoomState(true);
          } else {
            scale = 2.5;
            const rect = img.getBoundingClientRect();
            const tapX = e.touches[0].clientX - rect.left;
            const tapY = e.touches[0].clientY - rect.top;

            translateX = (rect.width / 2 - tapX) * scale;
            translateY = (rect.height / 2 - tapY) * scale;

            const limitX = (rect.width * (scale - 1)) / 2;
            const limitY = (rect.height * (scale - 1)) / 2;
            translateX = Math.max(-limitX, Math.min(limitX, translateX));
            translateY = Math.max(-limitY, Math.min(limitY, translateY));

            applyTransform(true);
          }
          e.preventDefault();
          lastTapTime = 0;
          return;
        }
        lastTapTime = now;

        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTx = translateX;
        startTy = translateY;
      } else if (e.touches.length === 2) {
        const dx = e.touches[0].clientX - e.touches[1].clientX;
        const dy = e.touches[0].clientY - e.touches[1].clientY;
        touchStartDist = Math.hypot(dx, dy);
        touchStartScale = scale;

        touchStartMidpoint = {
          x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
          y: (e.touches[0].clientY + e.touches[1].clientY) / 2
        };
        startTx = translateX;
        startTy = translateY;
      }
    });

    wrapper.addEventListener('touchmove', function (e) {
      if (window.innerWidth >= 992) return;

      if (e.touches.length === 1 && scale > 1) {
        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;

        const newTx = startTx + dx;
        const newTy = startTy + dy;

        const rect = img.getBoundingClientRect();
        const originalWidth = rect.width / scale;
        const originalHeight = rect.height / scale;

        const limitX = (originalWidth * (scale - 1)) / 2;
        const limitY = (originalHeight * (scale - 1)) / 2;

        // Check if dragging past vertical limits (pull to scroll/zoom-out)
        if (newTy < -limitY - 30 || newTy > limitY + 30) {
          resetZoomState(true);
          return;
        }

        e.preventDefault();

        translateX = Math.max(-limitX, Math.min(limitX, newTx));
        translateY = Math.max(-limitY, Math.min(limitY, newTy));

        applyTransform(false);
      } else if (e.touches.length === 2) {
        e.preventDefault();

        const dx = e.touches[0].clientX - e.touches[1].clientX;
        const dy = e.touches[0].clientY - e.touches[1].clientY;
        const dist = Math.hypot(dx, dy);

        let newScale = (dist / touchStartDist) * touchStartScale;
        newScale = Math.max(1, Math.min(4, newScale));

        const currentMidpoint = {
          x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
          y: (e.touches[0].clientY + e.touches[1].clientY) / 2
        };

        const wrapperRect = wrapper.getBoundingClientRect();
        const wCenter = wrapperRect.width / 2;
        const hCenter = wrapperRect.height / 2;

        const startMx = touchStartMidpoint.x - wrapperRect.left;
        const startMy = touchStartMidpoint.y - wrapperRect.top;

        const currentMx = currentMidpoint.x - wrapperRect.left;
        const currentMy = currentMidpoint.y - wrapperRect.top;

        translateX = currentMx - wCenter - (startMx - wCenter - startTx) * (newScale / touchStartScale);
        translateY = currentMy - hCenter - (startMy - hCenter - startTy) * (newScale / touchStartScale);

        scale = newScale;

        const rect = img.getBoundingClientRect();
        const originalWidth = rect.width / scale;
        const originalHeight = rect.height / scale;

        const limitX = (originalWidth * (scale - 1)) / 2;
        const limitY = (originalHeight * (scale - 1)) / 2;

        translateX = Math.max(-limitX, Math.min(limitX, translateX));
        translateY = Math.max(-limitY, Math.min(limitY, translateY));

        applyTransform(false);
      }
    }, { passive: false });

    wrapper.addEventListener('touchend', function (e) {
      if (window.innerWidth >= 992) return;
      if (e.touches.length === 1) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTx = translateX;
        startTy = translateY;
      }
      if (scale < 1.05) {
        resetZoomState(true);
      }
    });

    wrapper.addEventListener('touchcancel', function (e) {
      if (window.innerWidth >= 992) return;
      if (e.touches.length === 1) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTx = translateX;
        startTy = translateY;
      }
      if (scale < 1.05) {
        resetZoomState(true);
      }
    });
  });

  // Prevent default native page zoom on zoomModal when pinching
  if (zoomModal) {
    zoomModal.addEventListener('touchmove', function (e) {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  // 8. Zoom level x1 / x2 toggling and cursor tracking in modal (Desktop only)
  if (zoomModal && customCursor) {
    // Custom cursor tracking in modal (over image wrappers)
    zoomModal.addEventListener('mousemove', function (e) {
      if (window.innerWidth >= 992) {
        const hoverWrapper = e.target.closest('.zoom-modal__image-wrapper');
        if (hoverWrapper) {
          customCursor.style.display = 'inline-flex';
          customCursor.style.left = e.clientX + 'px';
          customCursor.style.top = e.clientY + 'px';
          
          if (hoverWrapper.classList.contains('is-zoomed')) {
            zoomInIcon?.classList.add('d-none');
            zoomOutIcon?.classList.remove('d-none');
          } else {
            zoomInIcon?.classList.remove('d-none');
            zoomOutIcon?.classList.add('d-none');
          }
        } else {
          customCursor.style.display = 'none';
        }
      }
    });

    zoomModal.addEventListener('mouseleave', function () {
      customCursor.style.display = 'none';
    });

    // Handle zoom toggling and origin panning
    zoomModalImages?.forEach(wrapper => {
      const img = wrapper.querySelector('.zoom-modal__image');

      wrapper.addEventListener('click', function (e) {
        if (window.innerWidth >= 992) {
          // Highlight active thumbnail immediately when image is clicked to zoom
          const idx = this.getAttribute('data-index');
          modalThumbnails?.forEach(t => {
            if (t.getAttribute('data-index') === idx) {
              t.classList.add('is-active');
            } else {
              t.classList.remove('is-active');
            }
          });

          this.classList.toggle('is-zoomed');
          if (this.classList.contains('is-zoomed')) {
            zoomInIcon?.classList.add('d-none');
            zoomOutIcon?.classList.remove('d-none');
            if (img) {
              const rect = this.getBoundingClientRect();
              const x = ((e.clientX - rect.left) / rect.width) * 100;
              const y = ((e.clientY - rect.top) / rect.height) * 100;
              img.style.transformOrigin = `${x}% ${y}%`;
            }
          } else {
            zoomInIcon?.classList.remove('d-none');
            zoomOutIcon?.classList.add('d-none');
            if (img) {
              img.style.transformOrigin = 'center center';
              img.style.transform = '';
              img.style.transition = '';
            }
          }
        }
      });

      wrapper.addEventListener('mousemove', function (e) {
        if (window.innerWidth >= 992 && this.classList.contains('is-zoomed') && img) {
          const rect = this.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
        }
      });
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.product-get-the-look-sticky-container');
  if (container) {
    const btn = container.querySelector('.get-the-look-btn');
    const details = container.querySelector('.product-get-the-look-details');
    if (btn && details) {
      const productImages = document.querySelector('.product-images-slider');
      const span = btn.querySelector('span');
      const originalText = span ? span.textContent.trim() : 'Get the Look';

      let isClosing = false;

      function openGetTheLook() {
        // Cancel any in-progress close animation
        details.classList.remove('is-closing');
        isClosing = false;
        details.classList.add('is-active');
        if (productImages) productImages.classList.add('gtl-active');
        if (span) span.textContent = 'Close';
      }

      function closeGetTheLook() {
        if (isClosing) return;
        isClosing = true;
        if (productImages) productImages.classList.remove('gtl-active');
        if (span) span.textContent = originalText;

        // Add is-closing to play the fadeOut animation; is-active stays during animation
        details.classList.add('is-closing');

        // Listen for the fadeOut animation to end, then fully close
        function onAnimationEnd(e) {
          // Only respond to the products fadeOut animation
          if (e.target.classList.contains('product-get-the-look-products')) {
            details.classList.remove('is-active');
            details.classList.remove('is-closing');
            isClosing = false;
            details.removeEventListener('animationend', onAnimationEnd);
          }
        }
        details.addEventListener('animationend', onAnimationEnd);
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (details.classList.contains('is-active')) {
          closeGetTheLook();
        } else {
          openGetTheLook();
        }
      });

      if (productImages) {
        productImages.addEventListener('click', function (e) {
          if (details.classList.contains('is-active') && !details.contains(e.target)) {
            closeGetTheLook();
          }
        });
      }
    }
  }

  // Product Shipping details slider/carousel logic
  function initProductShippingSliders() {
    const sliders = document.querySelectorAll('.product-shipping-details-slider');
    sliders.forEach(function(slider) {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';

      const slides = slider.querySelectorAll('.product-shipping-details-slide');
      if (slides.length <= 1) return;
      
      const ppBtn = slider.querySelector('.product-shipping-play-pause');
      let currentIndex = 0;
      let intervalId = null;
      let isPlaying = true;
      const speed = parseInt(slider.dataset.speed) || 4000;

      function showNext() {
        slides[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % slides.length;
        slides[currentIndex].classList.add('active');
      }

      function start() {
        stop();
        intervalId = setInterval(showNext, speed);
      }

      function stop() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }

      if (ppBtn) {
        ppBtn.addEventListener('click', function() {
          const iconPause = ppBtn.querySelector('.icon-pause');
          const iconPlay = ppBtn.querySelector('.icon-play');
          if (isPlaying) {
            stop();
            isPlaying = false;
            ppBtn.setAttribute('aria-label', 'Play rotation');
            ppBtn.dataset.state = 'paused';
            if (iconPause) iconPause.style.display = 'none';
            if (iconPlay) iconPlay.style.display = 'inline-block';
          } else {
            isPlaying = true;
            start();
            ppBtn.setAttribute('aria-label', 'Pause rotation');
            ppBtn.dataset.state = 'playing';
            if (iconPause) iconPause.style.display = 'inline-block';
            if (iconPlay) iconPlay.style.display = 'none';
          }
        });
      }

      start();
    });
  }

  initProductShippingSliders();

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      initProductShippingSliders();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  class SearchDrawer {
    constructor() {
      this.drawer = document.querySelector('.search-drawer');
      this.input = document.querySelector('.js-search-input');
      this.triggers = document.querySelectorAll('.js-search-trigger');
      this.closeButtons = document.querySelectorAll('.js-close-search');
      this.splide = null;
      this.resizeObserver = null;

      // Closed drawer starts out of the tab order and hidden from assistive tech
      if (this.drawer && !document.body.classList.contains('open-search')) {
        this.drawer.inert = true;
      }

      this.init();
    }

    init() {
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.js-search-trigger');
        if (trigger) {
          e.preventDefault();
          this.open();
        }

        const closeBtn = e.target.closest('.js-close-search');
        if (closeBtn) {
          e.preventDefault();
          this.close();
        }
      });

      if (this.input) {
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('open-search')) {
          this.close();
        }
      });

      // Robustness: Watch for class changes on body in case other scripts remove 'open-search'
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const isOpen = document.body.classList.contains('open-search');
            if (!isOpen && this.drawer.getAttribute('aria-hidden') === 'false') {
              this.close();
            }
          }
        });
      });
      observer.observe(document.body, { attributes: true });

      this.initSplide();
    }


    open() {
        if (document.body.classList.contains('open-menu')) {
        document.body.classList.remove('open-menu');
        const menuDrawer = document.querySelector('.snippet-menu-drawer');
        if (menuDrawer) {
          menuDrawer.style.height = '';
        }
        document.querySelectorAll('.menu-subcategories').forEach(function(subMenu){
          subMenu.classList.remove('hover-submenu');
        });
      }
      document.body.classList.add('open-search');
      document.body.classList.remove('open-drawer', 'open-sort', 'open-filter', 'open-view-drawer');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.drawer.inert = false;
      
      this.updateHeight();
      if (!this.resizeObserver) {
        const innerContent = this.drawer.querySelector('.search-drawer__content');
        this.resizeObserver = new ResizeObserver(() => this.updateHeight());
        if (innerContent) this.resizeObserver.observe(innerContent);
      }
      
      if (this.input) setTimeout(() => this.input.focus(), 400);
    }

    close() {
      // Return focus to the search trigger if it was inside the search UI
      const active = document.activeElement;
      if (active && (this.drawer.contains(active) || active.closest('.snippet-search-bar'))) {
        const trigger = document.querySelector('.js-search-trigger');
        if (trigger) setTimeout(() => trigger.focus(), 50);
      }
      document.body.classList.remove('open-search');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.drawer.inert = true;
      this.drawer.style.height = '0px';
      
      if (this.input) {
        this.input.value = '';
        const predictiveResults = document.querySelector('#predictive-search');
        if (predictiveResults) {
          predictiveResults.innerHTML = '';
          predictiveResults.style.display = 'none';
        }
        const suggestion = document.querySelector('.search-suggetion');
        if (suggestion) suggestion.style.display = "";
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    updateHeight() {
      if (!document.body.classList.contains('open-search')) {
        this.drawer.style.height = '0px';
        return;
      }

      if (window.innerWidth < 992) {
        this.drawer.style.height = '100svh';
        return;
      }

      const innerContent = this.drawer.querySelector('.search-drawer__content');
      if (!innerContent) return;
      const contentHeight = innerContent.offsetHeight;
      const totalHeight = contentHeight + 48; 

      if (document.body.classList.contains('open-search')) {
        this.drawer.style.height = totalHeight + 'px';
      }
    }


    initSplide() {
      const splideEl = document.querySelector('.js-trending-splide');
      if (!splideEl) return;

      this.splide = new Splide(splideEl, {
        type: 'slide',
        perPage: 1,
        fixedWidth: '74.65%',
        perMove: 1,
        gap: '12px',
        padding: { left: '12px', right: '12px' },
        // speed: 3000,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
        pagination: false,
        arrows: false,
        drag: 'free',
        dragMinThreshold: { mouse: 0, touch: 30 },
        mediaQuery: 'min',
        breakpoints: {
          992: {
            destroy: true
          }
        }
      });

      this.splide.mount();
      
      const prev = this.drawer ? this.drawer.querySelector('.trending-arrow--prev') : document.querySelector('.trending-arrow--prev');
      const next = this.drawer ? this.drawer.querySelector('.trending-arrow--next') : document.querySelector('.trending-arrow--next');
      if (prev) prev.addEventListener('click', () => this.splide.go('<'));
      if (next) next.addEventListener('click', () => this.splide.go('>'));

      const updateArrows = () => {
        if (!prev || !next) return;
        if (!this.splide || !this.splide.Components || !this.splide.Components.Controller) return;
        try {
          const lastIndex = this.splide.Components.Controller.getEnd();
          const isPrevDisabled = this.splide.index <= 0;
          const isNextDisabled = this.splide.index >= lastIndex;

          if (isPrevDisabled) {
            prev.setAttribute('disabled', 'disabled');
          } else {
            prev.removeAttribute('disabled');
          }
          prev.classList.toggle('is-inactive', isPrevDisabled);

          if (isNextDisabled) {
            next.setAttribute('disabled', 'disabled');
          } else {
            next.removeAttribute('disabled');
          }
          next.classList.toggle('is-inactive', isNextDisabled);
        } catch (e) {
          // ignore
        }
      };

      updateArrows();
      this.splide.on('mounted', updateArrows);
      this.splide.on('move', updateArrows);
      this.splide.on('moved', updateArrows);
      this.splide.on('updated', updateArrows);
      this.splide.on('resized', updateArrows);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.searchDrawerInstance = new SearchDrawer();
  });

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.search-drawer')) {
        window.searchDrawerInstance = new SearchDrawer();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
